"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailUserStatusToJSON = exports.MailUserStatusFromJSONTyped = exports.MailUserStatusFromJSON = exports.MailUserStatus = void 0;
/**
 * Mail user status.
 * @export
 * @enum {string}
 */
var MailUserStatus;
(function (MailUserStatus) {
    MailUserStatus["Active"] = "active";
    MailUserStatus["Inactive"] = "inactive";
})(MailUserStatus = exports.MailUserStatus || (exports.MailUserStatus = {}));
function MailUserStatusFromJSON(json) {
    return MailUserStatusFromJSONTyped(json, false);
}
exports.MailUserStatusFromJSON = MailUserStatusFromJSON;
function MailUserStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MailUserStatusFromJSONTyped = MailUserStatusFromJSONTyped;
function MailUserStatusToJSON(value) {
    return value;
}
exports.MailUserStatusToJSON = MailUserStatusToJSON;
